export default __webpack_public_path__ + "static/O0293-3275d1cd4962ee0102ba358aebdbe509.png";